import { useAtom } from '@reatom/npm-react'
import BigNumber from 'bignumber.js'
import { useMemo } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { reatomWalletSummary } from '@root/entities/summary'
import { SummaryTotal } from '@root/entities/summary/ui'
import { SummaryChart } from '@root/entities/summary/ui/summary-chart/mobile/summary-chart'

import type { WalletModel } from '@root/entities/wallet/atoms'
import type { ClassNameProps } from '@root/shared/react'

type Props = ClassNameProps & { wallet: WalletModel }

export const WalletSummary: React.FC<Props> = ({ className, wallet }) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomWalletSummary(wallet.id), [wallet.id])

  const [chartData] = useAtom(model.chartData)
  const [priceChangeState] = useAtom(model.priceChangeState)

  const [totalsNative] = useAtom(wallet.totalBalanceNative)
  const [totalsUsd] = useAtom(wallet.totalBalanceUsd)

  const totalsState = useMemo(
    () => AsyncStateN.success({ usd: totalsUsd, native: totalsNative }),
    [totalsNative, totalsUsd],
  )

  return (
    <Root className={className}>
      <SummaryTotal state={totalsState} />
      {chartData ? (
        <SummaryChart
          data={chartData}
          change={priceChangeState.value?.absolute ?? BigNumber(0)}
          changePercentage={priceChangeState.value?.percentage ?? 0}
        />
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 120px;
`
